import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../models'

import type { Router } from './feature'
import type { State } from './state'

/**
 * Core actions for this {@link Router}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Request to navigate to a new router state.
     *
     * Since it would be unusual to navigate without passing at least one
     * property of the {@link models.Request} object, we require at least one
     * property to be provided.
     *
     * @see {@link models.Request}
     */
    navigate: store.actions.request({
      input: (data: AtLeastOneOf<models.Request>): models.Request => data,
      output: store.actions.Data.NONE,
      reducers: {
        cancellation: ({ state }) => ({
          ...state,
          openRequests: state.openRequests - 1,
        }),
        error: ({ state }) => ({
          ...state,
          openRequests: state.openRequests - 1,
        }),
        request: ({ state }) => ({
          ...state,
          openRequests: state.openRequests + 1,
        }),
        success: ({ state }) => ({
          ...state,
          openRequests: state.openRequests - 1,
        }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
